class Helper {

  static getAPIState = ({ data, loading, error, fetchId } = {}) => {
    if (error && !data) return 'error';
    if (!data || (fetchId !== data?.product?.itemId && !data?.collection)) return 'loading';
    if (data && loading) {
      const { product } = data || {};
      const { itemId, media } = product || {};
      const { augmentedRealityLink, images, threeSixty, video } = media || {};
      const hasMedia = images?.length || video?.length || threeSixty?.length || augmentedRealityLink;
      if (hasMedia && fetchId === itemId) {
        return 'partial';
      }
      return 'loading';
    }
    return 'ready';
  };

  static AR_URL = 'https://assets.thdstatic.com/mobile-apps/2d/images/';

  static getStructuredMediaList = ({ mediaList, size = '145' }) => {
    return (mediaList || []).map((media) => {
      const { sizes, type, url } = media;
      if (type.match(/IMAGE/ig)) {
        if ((sizes || []).indexOf(size) > -1) {
          return {
            ...media,
            url: url.replace(/<SIZE>/ig, size)
          };
        }
        return null;
      } if (type.match(/VIDEO/ig)) {
        if (!media.url) {
          return null;
        } if (!media.videoStill) {
          media.videoStill = 'https://images.thdstatic.com/catalog/productImages/No_Image_145.jpg';
        }
      }
      return media;
    }).filter((media) => !!media
      && (
        Helper.isImage({ media })
        || Helper.isAR({ media })
        || Helper.isVideo({ media })
        || Helper.isImage360({ media })
      ));
  };

  /** *
   * Takes the initial media object containing the 3 media types and returns the array of media items
   * @param media
   * @returns {*[]}
   */
  static getInitialMediaList = ({ media }) => {
    const { augmentedRealityLink, images, threeSixty, video } = media || {};
    const videos = (video || []).map((v) => {
      return {
        ...v,
        id: v.videoId
      };
    });
    const augmentedReality = !(augmentedRealityLink?.image && augmentedRealityLink?.usdz) ? [] : [{
      ...augmentedRealityLink,
      mediaStill: `${Helper.AR_URL}${augmentedRealityLink.image}`,
      type: 'AUGMENTED_REALITY'
    }];
    const imagesWithIds = (images || []).map((image) => {
      return {
        ...image,
        id: image.url.split('/').pop().split('_')[0]
      };
    });

    // determine the start position for videos or 360 images
    const position = Math.min(imagesWithIds.length || 0, 2);
    const restOfImages = imagesWithIds.splice(position);
    // TODO: remove when type is added from API team
    const threeSixtyWithType = (threeSixty || []).map((item) => {
      return {
        ...item,
        mediaStill: `${item.url}/?thumb&profile=600`,
        type: 'THREESIXTY'
      };
    });
    return [...imagesWithIds, ...videos, ...(threeSixtyWithType || []), ...augmentedReality, ...restOfImages];

    // if (arAsset) {
    //   mediaList.push(arAsset)
    // }
    // return mediaList;
  };

  static isVideo = ({ media = {} }) => {
    const { type } = media;
    return /VIDEO/i.test(type);
  };

  static isImage360 = ({ media = {} }) => {
    const { type } = media;
    return type === 'THREESIXTY';
  };

  static isImage = ({ media = {} }) => {
    const { type } = media;
    return /IMAGE/i.test(type);
  };

  static isAR = ({ media = {} }) => {
    const { type } = media;
    return type === 'AUGMENTED_REALITY';
  };

  static normalizeImage = ({ image, size }) => {
    const { sizes, type, url } = image;
    const imageSize = sizes.indexOf(size) > -1 ? size : sizes.pop();
    return {
      ...image,
      mediaType: type,
      id: url.split('/').pop().split('_')[0],
      url: url.replace('<SIZE>', imageSize)
    };
  };

  // TODO: Check if this is still needed after AR asset is returned by API
  static normalizeARAsset = ({ product = {}, imageSize = '' }) => {
    const { augmentedRealityLink = [] } = product.media;

    let arAsset = augmentedRealityLink;
    // Normalize AR asset to match media list objects
    if (arAsset) {
      const usdz = arAsset.usdz && arAsset.usdz.length && arAsset.usdz[0];
      const assetLocation = arAsset.image;
      if (assetLocation && usdz) {
        const id = assetLocation.split('_')[0] || null;
        arAsset = {
          id,
          url: Helper.AR_URL + assetLocation,
          usdz,
          isAR: true,
          height: imageSize,
          type: 'AUGMENTED_REALITY'
        };
        return [arAsset];
      }
    }
    return [];
  };

  static isTouchEnabled = () => {
    if (typeof window !== 'undefined') {
      return ('ontouchstart' in window)
        || (navigator.maxTouchPoints > 0)
        || (navigator.msMaxTouchPoints > 0);
    }
    return false;
  }

  static getHighResImages(media, axios) {
    const { id, url } = media || {};
    if (id && url && this.isImage({ media })) {
      const locationArray = url.split('/');
      const fileName = locationArray.pop();
      const extension = fileName.substr(fileName.lastIndexOf('.') + 1);
      const highResImage = {
        ...media,
        url: `${locationArray.join('/')}/${id}_max.${extension}`
      };
      return axios.head(highResImage.url, {}).then(() => {
        return highResImage;
      }).catch(() => Promise.resolve(false));
    }
    return Promise.resolve(false);
  }
}

export default Helper;
